import { BaseResponseType } from "@/types/message";
import http from "./httpVideo";
import { activityRequestUrls } from "@/utils/messageUrl";



const { get, post } = http;

/**
 * 获取活动详情
 * @param data 
 * @returns 
 */
export const getActivityDetail = (data: any) :Promise<BaseResponseType> => {
  return get(`${activityRequestUrls.getActivityDetail}?surveyCode=${data}`);
}
/**
 * 提交报名
 * @param data 
 * @returns 
 */
export const saveActiviteSignup = (data: any) :Promise<BaseResponseType> => {
  return post(`${activityRequestUrls.submitActivitySignup}`, data);
}

/**
 * 校验是否已报名
 * @param data 
 * @returns 
 */
export const checkActiviteSignup = (data: any) :Promise<BaseResponseType> => {
  return get(`${activityRequestUrls.checkSignup}?surveyCode=${data}`);
}

/**
 * 获取活动记录
 * @param data 
 * @returns 
 */
export const getActivityRecords = (data: any) :Promise<BaseResponseType> => {
  return post(`${activityRequestUrls.getActivityRecords}`, data);
}